import Badanti from "./Badanti";

export default Badanti;
